import React from 'react';
import Layout from '../../constants/Layout';
import { AdvancedMarker } from './MapViewWeb';
import { getMarkerZIndex, getIconUri } from './MemoizedPantryMarkerUtils';

const MemoizedPantryMarker = React.memo(
  ({ pantry, selectedPantryId, showPantryDetails, selectPantry, getIcon }) => {
    const isActive = pantry.id === selectedPantryId;
    const onPress = (e) => {
      showPantryDetails(e, pantry);
      if (!Layout.usePantryTabs) {
        selectPantry(pantry.id);
      }
    };
    const iconSource = getIcon(pantry);
    const icon = getIconUri(iconSource);
    const zIndex = getMarkerZIndex(isActive, pantry.pantry_id);

    const coordinate = {
      latitude: parseFloat(pantry.latitude),
      longitude: parseFloat(pantry.longitude),
    };

    return (
      <AdvancedMarker
        position={{ lat: coordinate.latitude, lng: coordinate.longitude }}
        title={pantry.name}
        onClick={onPress}
        zIndex={zIndex}
      >
        <img src={icon} style={{ width: 28, height: 'auto' }} alt={pantry.name} />
      </AdvancedMarker>
    );
  }
);

export default MemoizedPantryMarker;
